/** @module Specification/LanguageSwitchboard */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/table/SwitchboardWidget"
], function (declare,locale,SwitchboardWidget) {

	return declare(SwitchboardWidget, {

		/**
		 * @override
		 * Return custom message
		 */
		_getNoResultDescription: function (hasColumnFilter, hasNewAction) {
			return locale.resource("ViewPlaceholderDescriptionLanguage");
		}
	});
});